import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 18v-12h-5v10a2 2 0 0 1 -2 2","key":"svg-0"}],["path",{"d":"M14 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4z","key":"svg-1"}]]

const IconCurrencySom = createReactComponent('outline', 'currency-som', 'CurrencySom', __iconNode);

export default IconCurrencySom;